/*
 * ============================================================
 * JJ – Ergänzungen: Lückenfüller im Warenkorb + «Auch im Set»
 * ============================================================
 * 1) <jj-lueckenfueller> (snippets/jj-lueckenfueller.liquid)
 *    Schlägt Kleinartikel bis zum Gratisversand vor – zuerst solche,
 *    die zum Warenkorb passen:
 *      a) «Passt dazu» der Warenkorbartikel (Metafeld custom.passt_dazu,
 *         von Liquid direkt mitgeliefert)
 *      b) gleicher Produkttyp      (/collections/types?q=…)
 *      c) gleiche Marke            (/collections/vendors?q=…)
 *      d) globale Liste mit dem Lückenfüller-Tag (/collections/all/<tag>)
 *    b–d über sections/jj-lueckenfueller-daten.liquid. Gezeigt werden
 *    kleine Karten mit «Hinzufügen».
 *
 * 2) Knöpfe mit [data-jj-add] (z. B. snippets/jj-auch-im-set.liquid)
 *    Legen die Variante aus data-variant mit der versteckten
 *    Eigenschaft _quelle (data-quelle) in den Warenkorb.
 *
 * 3) Messung «Weg zur Kasse» (Einstellung jj_kasse_messen): füllt beim
 *    Klick auf «Kasse» _kasse_breite, _kasse_geraet und _theme und
 *    vermerkt in _lf_gezeigt, wo Lückenfüller-Karten erschienen sind.
 *
 * Nach dem Hinzufügen wird dasselbe Ereignis ausgelöst wie beim
 * normalen Kaufknopf des Themes (product:added), damit sich der
 * Mini-Warenkorb neu aufbaut und öffnet. Auf der Warenkorbseite
 * wird cart:refresh ausgelöst (ohne Neuladen, ohne Hochscrollen).
 * ============================================================
 */
(function () {
  'use strict';

  var CACHE_MS = 10 * 60 * 1000; // Kandidatenliste 10 Minuten zwischenspeichern
  var speicher = {};             // Laufzeit-Zwischenspeicher je URL

  /* ---------------------------------------------------------- */
  /* Hilfsfunktionen                                             */
  /* ---------------------------------------------------------- */

  function routen() {
    return window.routes || {};
  }

  function themeInfo() {
    return window.theme || {};
  }

  function sessionLesen(schluessel) {
    try {
      var roh = window.sessionStorage.getItem(schluessel);
      if (!roh) return null;
      var eintrag = JSON.parse(roh);
      if (!eintrag || Date.now() - eintrag.zeit > CACHE_MS) return null;
      return eintrag.daten;
    } catch (e) {
      return null;
    }
  }

  function sessionSchreiben(schluessel, daten) {
    try {
      window.sessionStorage.setItem(schluessel, JSON.stringify({ zeit: Date.now(), daten: daten }));
    } catch (e) {
      // Privater Modus o. Ä. – dann eben ohne Zwischenspeicher
    }
  }

  // Liest das JSON aus der gerenderten Datensektion.
  function datenAusHtml(html) {
    var dok = new DOMParser().parseFromString(html, 'text/html');
    var skript = dok.querySelector('script[data-jj-lf-daten]');
    if (!skript) return [];
    try {
      var liste = JSON.parse(skript.textContent);
      return Array.isArray(liste) ? liste : [];
    } catch (e) {
      return [];
    }
  }

  function holeKandidaten(url) {
    var schluessel = 'jj-lf:' + url;
    var jetzt = Date.now();

    if (speicher[schluessel] && jetzt - speicher[schluessel].zeit < CACHE_MS) {
      return speicher[schluessel].versprechen;
    }

    var ausSession = sessionLesen(schluessel);
    if (ausSession) {
      var sofort = Promise.resolve(ausSession);
      speicher[schluessel] = { zeit: jetzt, versprechen: sofort };
      return sofort;
    }

    var versprechen = fetch(url, { credentials: 'same-origin' })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
        return antwort.text();
      })
      .then(function (html) {
        var liste = datenAusHtml(html);
        sessionSchreiben(schluessel, liste);
        return liste;
      })
      .catch(function (fehler) {
        delete speicher[schluessel];
        throw fehler;
      });

    speicher[schluessel] = { zeit: jetzt, versprechen: versprechen };
    return versprechen;
  }

  // Hauskonvention "Produktname - Marke": entfernt den Teil nach dem letzten
  // " - " (mit Leerzeichen), unabhängig von der Schreibweise im Feld vendor.
  function kurzTitel(titel) {
    if (!titel) return '';
    var pos = titel.lastIndexOf(' - ');
    return pos > 0 ? titel.slice(0, pos) : titel;
  }

  // Härtung: Links und Bildquellen nur aus dem eigenen Shop bzw. per https.
  // Die Kandidaten kommen aus Liquid und dem sessionStorage-Zwischenspeicher;
  // ein manipulierter Eintrag (z. B. «javascript:…») wird so nie ausführbar.
  function sichererLink(u) {
    u = typeof u === 'string' ? u.trim() : '';
    return /^\/(?!\/)/.test(u) || /^https:\/\//i.test(u) ? u : '#';
  }

  function sicheresBild(u) {
    u = typeof u === 'string' ? u.trim() : '';
    return /^(https:)?\/\//i.test(u) || /^\/(?!\/)/.test(u) ? u : '';
  }

  function element(tag, klasse, text) {
    var el = document.createElement(tag);
    if (klasse) el.className = klasse;
    if (text !== undefined && text !== null) el.textContent = text;
    return el;
  }

  /* ---------------------------------------------------------- */
  /* In den Warenkorb legen                                      */
  /* ---------------------------------------------------------- */

  /*
   * Vermerkt im Warenkorb-Attribut _jj_quellen, welcher Artikel über
   * welchen Block kam, z. B. "auch_im_set:900.023;lueckenfueller:103.816".
   * Das Attribut landet in der Bestellung (Zusätzliche Details / API
   * customAttributes) – auch dann, wenn eine Bundle-Function die Position
   * zerlegt und dabei Positions-Eigenschaften nicht übernimmt.
   */
  var QUELLEN_ATTRIBUT = '_jj_quellen';
  var QUELLEN_MAX = 30;

  function quelleVermerken(quelle, kennung) {
    if (!quelle) return Promise.resolve();
    var r = routen();
    var wurzel = r.rootUrl || '/';
    if (wurzel.slice(-1) !== '/') wurzel += '/';

    return fetch(wurzel + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (antwort) { return antwort.ok ? antwort.json() : null; })
      .then(function (cart) {
        var bisher = (cart && cart.attributes && cart.attributes[QUELLEN_ATTRIBUT]) || '';
        var liste = bisher ? String(bisher).split(';').filter(Boolean) : [];
        liste.push(quelle + ':' + (kennung || ''));
        if (liste.length > QUELLEN_MAX) liste = liste.slice(-QUELLEN_MAX);
        var attribute = {};
        attribute[QUELLEN_ATTRIBUT] = liste.join(';');
        return fetch(wurzel + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ attributes: attribute })
        });
      })
      .catch(function () {
        // Die Nachverfolgung darf das Hinzufügen nie verhindern.
      });
  }

  function inDenWarenkorb(variantenId, quelle, kennung, zusatz) {
    var r = routen();
    var eintrag = { id: Number(variantenId), quantity: 1 };
    if (quelle) {
      eintrag.properties = { _quelle: quelle };
      // Weitere versteckte Eigenschaften, z. B. _lf_grund (warum vorgeschlagen)
      if (zusatz) {
        Object.keys(zusatz).forEach(function (k) {
          if (zusatz[k]) eintrag.properties[k] = String(zusatz[k]);
        });
      }
    }

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    return fetch((r.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [eintrag] })
    })
      .then(function (antwort) {
        return antwort.json().then(function (inhalt) {
          if (!antwort.ok) {
            var fehler = new Error(inhalt.description || inhalt.message || 'Fehler');
            fehler.beschreibung = inhalt.description || '';
            throw fehler;
          }
          return inhalt;
        });
      })
      .then(function (inhalt) {
        return quelleVermerken(quelle, kennung || String(variantenId)).then(function () { return inhalt; });
      })
      .then(function (inhalt) {
        var t = themeInfo();

        if (t.pageType === 'cart') {
          // Warenkorbseite: Abschnitt neu aufbauen, nicht hochscrollen
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { scrollToTop: false }
          }));
        } else if (t.cartType === 'page') {
          window.location.href = r.cartUrl || '/cart';
        } else {
          // Gleiches Ereignis wie der Kaufknopf des Themes: Mini-Warenkorb
          // wird neu gerendert und geöffnet.
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: { button: null, variant: null, quantity: 1, productAdded: true }
          }));
        }
        return inhalt;
      })
      .catch(function (fehler) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        throw fehler;
      });
  }

  /* ---------------------------------------------------------- */
  /* Auswahl der Lückenfüller                                    */
  /* ---------------------------------------------------------- */

  /*
   * Globale Liste (Verhalten bis 09.10.2026, weiterhin als Auffüller):
   *
   * fehlt     Betrag bis zur Gratisversand-Grenze in Rappen (<= 0: erreicht)
   * toleranz  wie viel teurer als die Lücke ein Artikel sein darf, um
   *           noch als «passt genau» zu gelten (Rappen)
   *
   * Reihenfolge, wenn noch etwas fehlt:
   *   A  schliesst die Lücke knapp (Preis zwischen Lücke und Lücke + Toleranz),
   *      günstigster zuerst
   *   B  bringt näher heran (Preis unter der Lücke), teuerster zuerst
   *   C  schliesst die Lücke, ist aber deutlich teurer, günstigster zuerst
   * Ist die Grenze erreicht: Reihenfolge nach Verkäufen.
   * Danach wird auf Vielfalt geachtet: zuerst je Produkttyp höchstens ein
   * Artikel, erst dann wird aufgefüllt.
   */
  function auswaehlen(liste, fehlt, toleranz, anzahl, imKorb) {
    var kandidaten = liste.filter(function (p) {
      return p && p.v && !imKorb[String(p.id)];
    });

    var geordnet;
    if (fehlt > 0) {
      var a = kandidaten.filter(function (p) { return p.p >= fehlt && p.p <= fehlt + toleranz; })
        .sort(function (x, y) { return x.p - y.p; });
      var b = kandidaten.filter(function (p) { return p.p < fehlt; })
        .sort(function (x, y) { return y.p - x.p; });
      var c = kandidaten.filter(function (p) { return p.p > fehlt + toleranz; })
        .sort(function (x, y) { return x.p - y.p; });
      geordnet = a.concat(b, c);
    } else {
      geordnet = kandidaten;
    }

    // Artikel mit nur einer Variante (Ein-Klick) vor solchen, bei denen die
    // Kundin erst auf der Produktseite wählen muss.
    geordnet = geordnet.filter(function (p) { return !(p.n > 1); })
      .concat(geordnet.filter(function (p) { return p.n > 1; }));

    var wahl = [];
    var typen = {};
    geordnet.forEach(function (p) {
      if (wahl.length >= anzahl) return;
      var typ = (p.ty || '').toLowerCase() || ('id-' + p.id);
      if (typen[typ]) return;
      typen[typ] = true;
      wahl.push(p);
    });
    geordnet.forEach(function (p) {
      if (wahl.length >= anzahl) return;
      if (wahl.indexOf(p) === -1) wahl.push(p);
    });
    return wahl;
  }

  /*
   * Passende Vorschläge (ab 09.10.2026): zuerst passend, dann Lücke schliessen.
   *
   * 1. Relevanz je Kandidat (Summe über alle Warenkorbartikel):
   *      «Passt dazu»   10 / (1 + 0.35 × Rang)   Rang 0 = 10, Rang 3 ≈ 4.9
   *      gleicher Typ    4 / (1 + 0.05 × Rang)   Rang = Platz nach Verkäufen
   *      gleiche Marke 1.5 / (1 + 0.05 × Rang)
   *      mehrere Varianten (kein Ein-Klick)  − 1
   *    grund = Kategorie mit dem grössten Beitrag (passt_dazu | typ | marke).
   *
   * 2. Preisgrenze: Fehlt wenig, gilt «Passende Vorschläge bis» (Vorgabe 30).
   *    Fehlt mehr, steigt sie auf fehlender Betrag + Toleranz, höchstens bis
   *    zur «Obergrenze, um die Lücke zu schliessen» (Vorgabe 60). Beispiel:
   *    fehlen CHF 20, sind Artikel bis CHF 35 erlaubt.
   *
   * 3. Reihenfolge: Unter den passendsten (bis 12, mindestens 20 % der
   *    Punkte des besten) kommen die zuerst, die die Lücke schliessen
   *    (Preis zwischen Lücke und Lücke + Toleranz), nach Relevanz. Danach
   *    alle übrigen nach Relevanz. Solche Karten tragen «Damit portofrei».
   *
   * Rückblick-Test (Bestellungen Okt 25–Sep 26): Trefferquote praktisch wie
   * reine Relevanz (23.4 % gegenüber 24.0 %), aber bei schliessbaren Lücken
   * (bis CHF 45) zeigt der Block in 58 % der Fälle einen passenden Artikel,
   * der die Lücke schliesst (reine Relevanz: 39 %).
   */
  var GEWICHT = { passt_dazu: 10, typ: 4, marke: 1.5 };
  var ABFALL = { passt_dazu: 0.35, typ: 0.05, marke: 0.05 };
  var RELEVANT_MAX = 12;
  var RELEVANT_ANTEIL = 0.2;

  // Preisgrenze nach fehlendem Betrag (alles in Rappen)
  function preisGrenze(opt) {
    var basis = opt.maxPreis || 0;
    if (!basis) return 0;
    var fehlt = opt.fehlt || 0;
    if (fehlt <= 0) return basis;
    var deckel = Math.max(basis, opt.maxPreisLuecke || basis);
    return Math.min(deckel, Math.max(basis, fehlt + (opt.toleranz || 0)));
  }

  function schliesst(p, opt) {
    var fehlt = opt.fehlt || 0;
    return fehlt > 0 && p.p >= fehlt;
  }

  function bewerten(kontext, pools, opt) {
    var tabelle = {};
    var imKorb = opt.imKorb || {};
    var minPreis = opt.minPreis || 0;
    var maxPreis = preisGrenze(opt);

    function zulaessig(p) {
      if (!p || !p.v || imKorb[String(p.id)]) return false;
      if (minPreis > 0 && p.p < minPreis) return false;
      if (maxPreis > 0 && p.p > maxPreis) return false;
      return true;
    }

    function punkte(p, art, rang) {
      if (!zulaessig(p)) return;
      var schluessel = String(p.id);
      var eintrag = tabelle[schluessel];
      if (!eintrag) {
        eintrag = tabelle[schluessel] = { p: p, punkte: 0, anteile: { passt_dazu: 0, typ: 0, marke: 0 } };
      }
      var wert = GEWICHT[art] / (1 + ABFALL[art] * rang);
      eintrag.punkte += wert;
      eintrag.anteile[art] += wert;
    }

    ((kontext && kontext.passt) || []).forEach(function (eintrag) {
      ((eintrag && eintrag.liste) || []).forEach(function (p, rang) { punkte(p, 'passt_dazu', rang); });
    });

    var typen = (pools && pools.typ) || {};
    Object.keys(typen).forEach(function (typ) {
      (typen[typ] || []).forEach(function (p, rang) { punkte(p, 'typ', rang); });
    });

    var marken = (pools && pools.marke) || {};
    Object.keys(marken).forEach(function (marke) {
      (marken[marke] || []).forEach(function (p, rang) { punkte(p, 'marke', rang); });
    });

    return Object.keys(tabelle).map(function (k) {
      var e = tabelle[k];
      if (e.p.n > 1) e.punkte -= 1;

      var grund = 'marke';
      if (e.anteile.passt_dazu >= e.anteile.typ && e.anteile.passt_dazu >= e.anteile.marke && e.anteile.passt_dazu > 0) {
        grund = 'passt_dazu';
      } else if (e.anteile.typ >= e.anteile.marke && e.anteile.typ > 0) {
        grund = 'typ';
      }
      return { p: e.p, punkte: e.punkte, grund: grund };
    }).sort(function (x, y) {
      return y.punkte - x.punkte || y.p.p - x.p.p;
    });
  }

  /*
   * Wählt bis zu «anzahl» Vorschläge: passende (Schliesser zuerst, höchstens
   * maxTyp vom gleichen Produkttyp), dann aus der globalen Liste aufgefüllt
   * (alte Logik). Ergebnis: [{ p, grund, schliesst }].
   */
  function auswaehlenPassend(kontext, pools, opt) {
    var anzahl = opt.anzahl || 3;
    var maxTyp = Math.max(1, opt.maxTyp || 2);
    var fehlt = opt.fehlt || 0;
    var toleranz = opt.toleranz || 0;
    var wahl = [];
    var proTyp = {};
    var gewaehlt = {};

    var bewertet = bewerten(kontext, pools, opt);
    var geordnet = bewertet;
    if (fehlt > 0 && bewertet.length > 0) {
      var bester = bewertet[0].punkte;
      var relevant = bewertet.slice(0, RELEVANT_MAX).filter(function (e) {
        return e.punkte >= bester * RELEVANT_ANTEIL;
      });
      var schliesser = relevant.filter(function (e) {
        return e.p.p >= fehlt && e.p.p <= fehlt + toleranz;
      });
      geordnet = schliesser.concat(bewertet.filter(function (e) { return schliesser.indexOf(e) === -1; }));
    }

    geordnet.forEach(function (e) {
      if (wahl.length >= anzahl) return;
      var typ = (e.p.ty || '').toLowerCase() || ('id-' + e.p.id);
      if ((proTyp[typ] || 0) >= maxTyp) return;
      proTyp[typ] = (proTyp[typ] || 0) + 1;
      gewaehlt[String(e.p.id)] = true;
      wahl.push({ p: e.p, grund: e.grund, schliesst: schliesst(e.p, opt) });
    });

    if (wahl.length < anzahl) {
      var ausschluss = {};
      Object.keys(opt.imKorb || {}).forEach(function (k) { ausschluss[k] = true; });
      Object.keys(gewaehlt).forEach(function (k) { ausschluss[k] = true; });
      auswaehlen((pools && pools.liste) || [], fehlt, toleranz, anzahl - wahl.length, ausschluss)
        .forEach(function (p) { wahl.push({ p: p, grund: 'liste', schliesst: schliesst(p, opt) }); });
    }
    return wahl;
  }

  /* ---------------------------------------------------------- */
  /* <jj-lueckenfueller>                                         */
  /* ---------------------------------------------------------- */

  var MAX_TYP_ABRUFE = 3;    // höchstens so viele Produkttypen nachladen
  var MAX_MARKEN_ABRUFE = 2; // höchstens so viele Marken nachladen

  function kontextLesen(element) {
    var skript = element.querySelector('script[data-jj-lf-kontext]');
    if (!skript) return null;
    try {
      var k = JSON.parse(skript.textContent);
      return k && typeof k === 'object' ? k : null;
    } catch (e) {
      return null;
    }
  }

  // Verschiedene, nicht leere Werte in der Reihenfolge des Warenkorbs
  function eindeutig(werte, max) {
    var gesehen = {};
    var liste = [];
    werte.forEach(function (w) {
      var t = (w || '').trim();
      if (!t || gesehen[t.toLowerCase()] || liste.length >= max) return;
      gesehen[t.toLowerCase()] = true;
      liste.push(t);
    });
    return liste;
  }

  // Abruf, der nie fehlschlägt: bei Fehler leere Liste
  function sicherHolen(url) {
    return holeKandidaten(url).catch(function () { return []; });
  }

  class Lueckenfueller extends HTMLElement {
    connectedCallback() {
      if (this._gestartet) return;
      this._gestartet = true;

      var self = this;
      var url = this.getAttribute('data-quelle');
      if (!url) return;

      // Mini-Warenkorb als Popover (ab 641 px): Vorschläge ausgeschaltet,
      // dort steht nur der Hinweis mit Balken (siehe jj-lueckenfueller.liquid).
      if (this.hasAttribute('data-nur-mobil') && window.matchMedia
          && window.matchMedia('(min-width: 641px)').matches) {
        return;
      }
      // Umgekehrt: Karten nur ab 641 px, auf dem Handy nur der Hinweis.
      if (this.hasAttribute('data-nur-gross') && window.matchMedia
          && !window.matchMedia('(min-width: 641px)').matches) {
        return;
      }

      var kontext = this.getAttribute('data-kontext') === 'an' ? kontextLesen(this) : null;
      var anzahl = this._anzahl();

      var abrufe = { liste: sicherHolen(url), typ: {}, marke: {} };

      if (kontext && Array.isArray(kontext.artikel) && kontext.artikel.length > 0) {
        // Wie viele «Passt dazu»-Kandidaten liefert Liquid schon?
        var passtIds = {};
        (kontext.passt || []).forEach(function (e) {
          ((e && e.liste) || []).forEach(function (p) { if (p && p.id) passtIds[p.id] = true; });
        });
        var passtAnzahl = Object.keys(passtIds).length;

        var basisTyp = this.getAttribute('data-quelle-typ');
        var basisMarke = this.getAttribute('data-quelle-marke');

        // Gleicher Typ: immer (liefert auch teurere Artikel derselben Serie,
        // die eine grössere Lücke schliessen, z. B. ein grosses Lichthaus)
        if (basisTyp) {
          eindeutig(kontext.artikel.map(function (a) { return a.ty; }), MAX_TYP_ABRUFE).forEach(function (typ) {
            abrufe.typ[typ] = sicherHolen(basisTyp + encodeURIComponent(typ));
          });
        }
        // Gleiche Marke: nur, wenn «Passt dazu» weniger als die Anzahl liefert
        if (basisMarke && passtAnzahl < anzahl) {
          eindeutig(kontext.artikel.map(function (a) { return a.vd; }), MAX_MARKEN_ABRUFE).forEach(function (marke) {
            abrufe.marke[marke] = sicherHolen(basisMarke + encodeURIComponent(marke));
          });
        }
      }

      var typNamen = Object.keys(abrufe.typ);
      var markenNamen = Object.keys(abrufe.marke);
      var alle = [abrufe.liste]
        .concat(typNamen.map(function (t) { return abrufe.typ[t]; }))
        .concat(markenNamen.map(function (m) { return abrufe.marke[m]; }));

      Promise.all(alle)
        .then(function (ergebnisse) {
          var pools = { liste: ergebnisse[0] || [], typ: {}, marke: {} };
          typNamen.forEach(function (t, i) { pools.typ[t] = ergebnisse[1 + i] || []; });
          markenNamen.forEach(function (m, i) { pools.marke[m] = ergebnisse[1 + typNamen.length + i] || []; });
          self._zeichnen(pools, kontext);
        })
        .catch(function () { /* Ohne Daten bleibt der Block unsichtbar */ });
    }

    _zahl(attribut, standard) {
      var wert = parseInt(this.getAttribute(attribut), 10);
      return isNaN(wert) ? standard : wert;
    }

    // Handy: data-anzahl (Vorgabe 3). Warenkorbseite ab 1000 px: data-anzahl-gross
    // (Vorgabe 5), auf dem Tablet (641–999 px) höchstens 4.
    _anzahl() {
      var anzahl = this._zahl('data-anzahl', 3);
      var gross = this._zahl('data-anzahl-gross', 0);
      if (gross > 0 && window.matchMedia) {
        if (window.matchMedia('(min-width: 1000px)').matches) anzahl = gross;
        else if (window.matchMedia('(min-width: 641px)').matches) anzahl = Math.min(4, gross);
      }
      return Math.max(1, Math.min(6, anzahl));
    }

    _zeichnen(pools, kontext) {
      var imKorb = {};
      (this.getAttribute('data-im-korb') || '').split(',').forEach(function (id) {
        if (id) imKorb[id.trim()] = true;
      });

      var opt = {
        fehlt: this._zahl('data-fehlt', 0),
        toleranz: this._zahl('data-toleranz', 1500),
        anzahl: this._anzahl(),
        imKorb: imKorb,
        minPreis: this._zahl('data-min-preis', 0),
        maxPreis: this._zahl('data-max-preis', 0),
        maxPreisLuecke: this._zahl('data-max-preis-luecke', 0),
        maxTyp: this._zahl('data-max-typ', 2)
      };

      var wahl;
      if (kontext) {
        wahl = auswaehlenPassend(kontext, pools, opt);
      } else {
        wahl = auswaehlen(pools.liste || [], opt.fehlt, opt.toleranz, opt.anzahl, imKorb)
          .map(function (p) { return { p: p, grund: 'liste', schliesst: schliesst(p, opt) }; });
      }

      var container = this.querySelector('.jj-lf__liste');
      if (!container || wahl.length === 0) {
        this.hidden = true;
        return;
      }

      container.innerHTML = '';
      var self = this;
      wahl.forEach(function (w) { container.appendChild(self._karte(w.p, w.grund, w.schliesst)); });

      this.style.setProperty('--jj-lf-spalten', String(wahl.length));
      this.hidden = false;

      // Messung: Karten sind sichtbar – Ort am Warenkorb vermerken
      if (this.hasAttribute('data-messen')) {
        lfGezeigtVermerken(this.getAttribute('data-ort') || 'mini', this.getAttribute('data-lf-gezeigt'));
      }
    }

    _karte(p, grund, schliesstLuecke) {
      var self = this;
      var titel = kurzTitel(p.t);

      var karte = element('div', 'jj-lf__karte' + (schliesstLuecke ? ' jj-lf__karte--portofrei' : ''));
      karte.setAttribute('role', 'listitem');
      if (grund) karte.setAttribute('data-grund', grund);

      var bildLink = element('a', 'jj-lf__bild');
      bildLink.href = sichererLink(p.u);
      bildLink.tabIndex = -1;
      bildLink.setAttribute('aria-hidden', 'true');
      if (sicheresBild(p.i)) {
        var bild = document.createElement('img');
        bild.src = sicheresBild(p.i);
        bild.alt = '';
        bild.loading = 'lazy';
        bild.width = 150;
        bild.height = 150;
        bildLink.appendChild(bild);
      }
      karte.appendChild(bildLink);

      var name = element('a', 'jj-lf__name', titel);
      name.href = sichererLink(p.u);
      name.title = titel;
      karte.appendChild(name);

      var preis = element('div', 'jj-lf__preis');
      if (p.c && p.c > p.p) {
        preis.appendChild(element('span', 'jj-lf__preis-aktuell jj-lf__preis-aktuell--aktion', p.ph));
        preis.appendChild(element('span', 'jj-lf__preis-vorher', p.ch));
      } else {
        preis.appendChild(element('span', 'jj-lf__preis-aktuell', p.ph));
      }
      karte.appendChild(preis);

      var textPortofrei = this.getAttribute('data-text-schliesst');
      if (schliesstLuecke && textPortofrei) {
        karte.appendChild(element('div', 'jj-lf__portofrei', textPortofrei));
      }

      if (p.n > 1) {
        // Mehrere Varianten: zur Produktseite, damit die Kundin wählen kann
        var ansehen = element('a', 'jj-lf__knopf button button--secondary', this.getAttribute('data-text-ansehen'));
        ansehen.href = sichererLink(p.u);
        karte.appendChild(ansehen);
      } else {
        var knopf = element('button', 'jj-lf__knopf button button--primary', '+ ' + this.getAttribute('data-text-hinzufuegen'));
        knopf.type = 'button';
        knopf.setAttribute('aria-label', (this.getAttribute('data-text-hinzufuegen-label') || '').replace('__TITEL__', titel));
        knopf.addEventListener('click', function (ereignis) {
          ereignis.preventDefault();
          ereignis.stopPropagation();
          self._hinzufuegen(p, knopf, grund);
        });
        karte.appendChild(knopf);
      }
      return karte;
    }

    _hinzufuegen(p, knopf, grund) {
      var self = this;
      var meldung = this.querySelector('.jj-lf__meldung');
      var originalText = knopf.textContent;

      knopf.disabled = true;
      knopf.textContent = this.getAttribute('data-text-laedt');
      if (meldung) meldung.hidden = true;

      inDenWarenkorb(p.v, 'lueckenfueller', p.s || String(p.v), { _lf_grund: grund || 'liste' })
        .then(function () {
          // Normalerweise baut das Theme den Warenkorb neu auf und ersetzt
          // dieses Element. Steht der Knopf danach noch da, zurücksetzen.
          setTimeout(function () {
            if (document.body.contains(knopf)) {
              knopf.disabled = false;
              knopf.textContent = originalText;
            }
          }, 2000);
        })
        .catch(function (fehler) {
          knopf.disabled = false;
          knopf.textContent = originalText;
          if (meldung) {
            meldung.textContent = fehler.beschreibung || self.getAttribute('data-text-fehler');
            meldung.hidden = false;
          }
        });
    }
  }

  /* ---------------------------------------------------------- */
  /* Weg zur Kasse messen: Werte beim Klick auf «Kasse»           */
  /* (versteckte Felder in Mini-Warenkorb und Warenkorbseite,      */
  /* nur wenn jj_kasse_messen an ist):                             */
  /*   _kasse_breite  Bildschirmbreite in px                       */
  /*   _kasse_geraet  touch (Finger als Hauptzeiger) | maus        */
  /*   _theme         Name des Themes, bei Vorschau «[vorschau]»   */
  /* ---------------------------------------------------------- */

  function geraetErkennen() {
    if (!window.matchMedia) return 'unbekannt';
    if (window.matchMedia('(pointer: coarse)').matches) return 'touch';
    if (window.matchMedia('(pointer: fine)').matches) return 'maus';
    return 'unbekannt';
  }

  function themeKennung() {
    var t = (window.Shopify && window.Shopify.theme) || {};
    var name = String(t.name || t.id || '').trim();
    if (!name) return '';
    if (t.role && t.role !== 'main') name += ' [vorschau]';
    return name.slice(0, 120);
  }

  function feldSetzen(form, schluessel, wert) {
    var feld = form.querySelector('input[name="attributes[' + schluessel + ']"]');
    if (feld) feld.value = wert;
  }

  document.addEventListener('submit', function (ereignis) {
    try {
      var form = ereignis.target;
      if (!form || !form.querySelector) return;
      feldSetzen(form, '_kasse_breite', String(Math.round(window.innerWidth || 0)));
      feldSetzen(form, '_kasse_geraet', geraetErkennen());
      feldSetzen(form, '_theme', themeKennung());
    } catch (e) { /* Messung darf den Weg zur Kasse nie aufhalten */ }
  }, true);

  /*
   * Lückenfüller gesehen: vermerkt im Warenkorb-Attribut _lf_gezeigt,
   * wo Karten tatsächlich erschienen sind (mini, seite oder mini,seite).
   * Geschrieben wird nur, wenn der Ort neu ist – höchstens einmal je
   * Ort und Seitenaufruf.
   */
  var LF_GEZEIGT_ATTRIBUT = '_lf_gezeigt';
  var lfGezeigtGemeldet = {};

  function lfGezeigtVermerken(ort, bisher) {
    try {
      if (!ort || lfGezeigtGemeldet[ort]) return;
      var liste = String(bisher || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      Object.keys(lfGezeigtGemeldet).forEach(function (o) {
        if (liste.indexOf(o) === -1) liste.push(o);
      });
      lfGezeigtGemeldet[ort] = true;
      if (liste.indexOf(ort) !== -1) return;
      liste.push(ort);
      liste.sort();

      var r = routen();
      var wurzel = r.rootUrl || '/';
      if (wurzel.slice(-1) !== '/') wurzel += '/';
      var attribute = {};
      attribute[LF_GEZEIGT_ATTRIBUT] = liste.join(',');
      fetch(wurzel + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ attributes: attribute })
      }).catch(function () { delete lfGezeigtGemeldet[ort]; });
    } catch (e) { /* Messung darf nie stören */ }
  }

  if (!window.customElements.get('jj-lueckenfueller')) {
    window.customElements.define('jj-lueckenfueller', Lueckenfueller);
  }

  /* ---------------------------------------------------------- */
  /* Knöpfe [data-jj-add] (z. B. «Auch im Set»)                  */
  /* ---------------------------------------------------------- */

  document.addEventListener('click', function (ereignis) {
    var knopf = ereignis.target.closest ? ereignis.target.closest('[data-jj-add]') : null;
    if (!knopf || knopf.disabled) return;

    // Liegt der Knopf im Produktformular, darf das Formular nicht senden.
    ereignis.preventDefault();
    ereignis.stopPropagation();

    var variante = knopf.getAttribute('data-variant');
    var quelle = knopf.getAttribute('data-quelle') || '';
    var kennung = knopf.getAttribute('data-sku') || variante;
    var textLaedt = knopf.getAttribute('data-text-laedt');
    var textFehler = knopf.getAttribute('data-text-fehler');
    var meldung = null;
    var box = knopf.closest('[data-jj-add-box]');
    if (box) meldung = box.querySelector('[data-jj-add-meldung]');

    var originalHtml = knopf.innerHTML;
    knopf.disabled = true;
    if (textLaedt) knopf.textContent = textLaedt;
    if (meldung) meldung.hidden = true;

    inDenWarenkorb(variante, quelle, kennung)
      .then(function () {
        knopf.disabled = false;
        knopf.innerHTML = originalHtml;
      })
      .catch(function (fehler) {
        knopf.disabled = false;
        knopf.innerHTML = originalHtml;
        if (meldung) {
          meldung.textContent = fehler.beschreibung || textFehler || '';
          meldung.hidden = false;
        }
      });
  }, true);

  /* ---------------------------------------------------------- */
  /* «Auch im Set»: Auswahl bei mehreren Sets                     */
  /* ---------------------------------------------------------- */

  document.addEventListener('change', function (ereignis) {
    var wahl = ereignis.target;
    if (!wahl || !wahl.matches || !wahl.matches('[data-jj-set-wahl]')) return;

    var box = wahl.closest('[data-jj-add-box]');
    if (!box) return;
    var knopf = box.querySelector('[data-jj-set-knopf]');
    var link = box.querySelector('[data-jj-set-link]');

    if (knopf) {
      knopf.setAttribute('data-variant', wahl.value);
      knopf.setAttribute('data-sku', wahl.getAttribute('data-sku') || '');
      var stueck = parseInt(wahl.getAttribute('data-stueck'), 10);
      knopf.textContent = stueck === 2
        ? knopf.getAttribute('data-text-beide')
        : knopf.getAttribute('data-text-set');
      var label = knopf.getAttribute('data-text-label');
      if (label) knopf.setAttribute('aria-label', label.replace('__TITEL__', wahl.getAttribute('data-titel') || ''));
    }
    if (link && wahl.getAttribute('data-url')) {
      link.href = sichererLink(wahl.getAttribute('data-url'));
    }
  });

  // Für spätere Erweiterungen und Tests von aussen erreichbar
  window.JJErgaenzungen = {
    auswaehlen: auswaehlen,
    bewerten: bewerten,
    auswaehlenPassend: auswaehlenPassend,
    preisGrenze: preisGrenze,
    inDenWarenkorb: inDenWarenkorb,
    kurzTitel: kurzTitel,
    sichererLink: sichererLink,
    sicheresBild: sicheresBild,
    quelleVermerken: quelleVermerken
  };
})();
